
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dvmRd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f24ac019fdca6223$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $f24ac019fdca6223$export$2e2bcd8739ae039 = {
    'confluence.error.panel.refresh.app': "\u30A2\u30D7\u30EA\u3092\u66F4\u65B0",
    'confluence.error.panel.reload.page': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0",
    'confluence.icon.label': "\u30A2\u30A4\u30B3\u30F3",
    'confluence.modal.dialog.close.modal.button': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'confluence.select.required.field.message': "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
    'confluence.text.area.required.field.message': "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
    'confluence.textfield.validator.email': "\u6709\u52B9\u306A\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'confluence.textfield.validator.number': "\u6709\u52B9\u306A\u6570\u5B57\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044",
    'confluence.textfield.validator.required.field.message': "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
    'confluence.textfield.validator.telephone': "\u6709\u52B9\u306A\u96FB\u8A71\u756A\u53F7\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002",
    'confluence.threeLOPrompt.modal.access.required.title': "\u30A2\u30AF\u30BB\u30B9\u6A29\u304C\u5FC5\u8981\u3067\u3059\u3002",
    'confluence.threeLOPrompt.modal.error.title': "\u30A8\u30E9\u30FC",
    'confluence.threeLOPrompt.modal.no.authURL.error-message': "\u540C\u610F URL \u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'confluence.threeLOPrompt.no.authURL.error-message': "\u540C\u610F URL \u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'confluence.threeLOPrompt.use-auth.allow.access.button.text': "\u30A2\u30AF\u30BB\u30B9\u3092\u8A31\u53EF",
    'confluence.threeLOPrompt.use-auth.configure.access.button.text': "\u30A2\u30AF\u30BB\u30B9\u3092\u8A2D\u5B9A",
    'confluence.threeLOPrompt.use-auth.default.failed.to.auth.message': "\u8A8D\u8A3C\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002",
    'confluence.threeLOPrompt.use-auth.default.prompt.message': "{appString} \u3092\u8868\u793A\u3059\u308B\u306B\u306F\u3001\u30A2\u30D7\u30EA\u304C\u304A\u5BA2\u69D8\u306B\u4EE3\u308F\u3063\u3066\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3\u88FD\u54C1\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002",
    'confluence.threeLOPrompt.use-auth.external.auth.prompt.message': "{appString} \u3067\u306F\u3001\u30A2\u30AB\u30A6\u30F3\u30C8\u3078\u306E\u8FFD\u52A0\u306E\u30A2\u30AF\u30BB\u30B9\u6A29\u304C\u5FC5\u8981\u3067\u3059\u3002",
    'confluence.threeLOPrompt.use-auth.external.auth.warning.message': "\u5916\u90E8\u8A8D\u8A3C\u306E\u8B66\u544A",
    'confluence.threeLOPrompt.use-auth.this.app.lower.message': "\u3053\u306E\u30A2\u30D7\u30EA",
    'confluence.threeLOPrompt.use-auth.this.app.upper.message': "\u3053\u306E\u30A2\u30D7\u30EA",
    'confluence.user.group.unknown.user.message': "\u4E0D\u660E\u306A\u30E6\u30FC\u30B6\u30FC",
    'confluence.user.picker.empty.field.error.message': "\u3053\u306E\u30D5\u30A3\u30FC\u30EB\u30C9\u306F\u5FC5\u9808\u3067\u3059\u3002",
    'confluence.user.unknown.user.message': "\u4E0D\u660E\u306A\u30E6\u30FC\u30B6\u30FC",
    'forge-ui.form.submit-button.text': "\u9001\u4FE1"
};

});


//# sourceMappingURL=ja.6c796bd3.js.map
